module.exports = __webpack_public_path__ + "media/theme/steps--3--close-0ddfa0c0.png";